import React from 'react';
import { Tag, Wrapper } from 'components';
import { Appearance } from 'design';

interface ICreditCardFeesItemProps {
  percentFee?: number;
}

const getDeductionRate = (percentFee: number) => `CC Deduction Rate: ${percentFee} %`;

export const CreditCardFeesItem: React.FC<ICreditCardFeesItemProps> = ({ percentFee = 0 }) => (
  <Wrapper direction="row" alignItems="center">
    <Tag dataCy="cc-deduction-rate-tag" label={getDeductionRate(percentFee)} appearance={Appearance.SECONDARY} capitalize={false} />
  </Wrapper>
);
